
<template >
  <div id="app" modo="popup">
    <component
      :is="componenteCarregado"
      v-bind="currentProperties"
      class="janelaPopup"
    ></component>
  </div>
</template>

<script>
import "@/css/principal.css";
import "@/css/popup.css";


export default {
  mixins: [ ],

  data() {
    return {
      componenteCarregado: "",
      param: {},
    };
  },

  created() {
    window.app = window.opener.window.app; //tornando o vue deste componente visível pelo javascrpt mesmo acessando externamente

    var objMnuPai =
      window.opener.window.app.$store.state.menuStore.menuGeralApp;
    window.rootMenu = objMnuPai.length
      ? objMnuPai
      : window.opener.window.rootMenu; //pego o menu na store da janela pai pra não precisar ir no banco recarregar

    //chama o carrega componente pra obter o componente que eu preciso renderizar no popup. Ao terminar de fazer o import, irá plotar o componente na tag component
    let paramURL = new URLSearchParams(window.location.search);
    let componente = paramURL.get("componenteVue");
    this.param = { codOperadora: paramURL.get("codOperadora") };

    this.componenteCarregado = this.carregaComponente(componente);
  },

  computed: {
    currentProperties() {
      return this.param;
    },
  },

  methods: {
    carregaComponente(componente) {
      var pages = require
        .context("@/pages/", true, /^.*\.vue$/)
        .keys()
        .map((m) => "pages" + m.substring(1));
      var caminho = pages.find(
        (e) => e.indexOf("/" + componente + ".vue") != -1
      );
      return () => import(`@/${caminho}`);
    },
  },
};
</script>
